import React from 'react';
import { RunStatePill, runState } from '../EtlPages';
import { MobileCard, timeAgo } from './EtlMobileKit';

/** Pipeline stages (etlFileProcessingState.lastErrorStage) in plain words. */
export const STAGE_LABEL = {
  received: 'Intake',
  ocrSubmit: 'OCR submit',
  ocrPoll: 'OCR',
  normalizer: 'Normalizer',
  archive: 'Archive',
  replay: 'Replay',
  resolve: 'Resolve',
};

export const stageLabel = (stage) => (stage ? (STAGE_LABEL[stage] || String(stage)) : null);

/** The file's own name, from wherever the pipeline last had it. */
export function issueFileName(row) {
  const path = row?.sourceBlobPath || row?.archivedBlobPath;
  if (path) {
    const clean = String(path).split('?')[0];
    const name = clean.split('/').filter(Boolean).pop();
    if (name) {
      try { return decodeURIComponent(name); } catch (_) { return name; }
    }
  }
  return `${row?.fileType || 'file'} · ${row?.effectiveDate ? String(row.effectiveDate).slice(0, 10) : `#${row?.id}`}`;
}

/**
 * Phone form of the issue table: one card per state row — mono file name,
 * "Property · File type · time", and the failing stage as an error-tinted
 * pill (the status pill when nothing failed). Tapping selects the row.
 */
export default function DlqCardList({
  rows, selectedId, onSelect, locationNameById, categoryLabel, statusLabel = {},
}) {
  return (
    <div className="ep-m ep-m-list ep-flush" data-testid="dlq-card-list">
      {rows.map((r) => {
        const s = runState(r.status);
        const property = locationNameById.get(r.locationId) || `Hotel ${r.locationId}`;
        const hasError = Boolean(r.lastErrorStage || r.lastErrorCategory || (r.lastErrorMessage || '').trim());
        const pillText = stageLabel(r.lastErrorStage)
          || (r.lastErrorCategory ? categoryLabel(r.lastErrorCategory) : null)
          || 'Error';
        const when = timeAgo(r.lastTransitionAt || r.receivedAt);
        return (
          <MobileCard
            key={r.id}
            icon={s.Icon}
            tone={s.tone}
            title={issueFileName(r)}
            titleClassName="ep-mono"
            sub={[property, r.fileType, when].filter(Boolean).join(' · ')}
            trailing={hasError
              ? <span className="ep-m-stage" title={r.lastErrorMessage || undefined}>{pillText}</span>
              : <RunStatePill status={r.status} label={statusLabel[r.status]} />}
            selected={selectedId === r.id}
            onClick={() => onSelect(r.id)}
            ariaLabel={`${issueFileName(r)}, ${property}, ${statusLabel[r.status] || s.label}`}
          />
        );
      })}
    </div>
  );
}
